
export interface RCMForegroundPlugin {
    bringToFront(): Promise<void>;
}

import { registerPlugin } from '@capacitor/core';

export const RCMForeground = registerPlugin<RCMForegroundPlugin>('RCMForegroundPlugin');